import { db, storage, functions } from './firebase';
import { collection, doc, addDoc, updateDoc, arrayUnion, serverTimestamp, onSnapshot } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';
import { withAuthErrorHandling } from '../utils/authErrorHandler';

const rossArtTeacher = httpsCallable(functions, 'rossArtTeacher');

export const sendToRoss = withAuthErrorHandling(async ({ message, messageHistory = [], imageUrl = null, intent = null, circleId = null }) => {
  const result = await rossArtTeacher({
    message: message?.trim() || '',
    imageUrl: imageUrl || null,
    intent: intent || null,
    circleId: circleId || null,
    messageHistory: messageHistory.slice(-10).map((msg) => ({
      role: msg.role === 'user' ? 'user' : 'model',
      parts: [{ text: msg.text || msg.content || '' }],
    })),
  });
  return result.data;
});

export async function saveMessage(circleId, message) {
  const circleRef = doc(db, 'artPingPongCircles', circleId);
  await updateDoc(circleRef, {
    messages: arrayUnion(message),
    lastUpdated: serverTimestamp(),
  });
}

export function subscribeToMessages(circleId, callback) {
  return onSnapshot(doc(db, 'artPingPongCircles', circleId), (snap) => {
    if (snap.exists()) {
      const data = snap.data();
      callback(data.messages || []);
    }
  });
}

export async function uploadImage(userId, imageBlob) {
  const filename = `${crypto.randomUUID()}.jpg`;
  const storageRef = ref(storage, `art-ping-pong/${userId}/${filename}`);
  const metadata = { contentType: 'image/jpeg' };
  await uploadBytes(storageRef, imageBlob, metadata);
  return getDownloadURL(storageRef);
}

export const styleTransferImage = withAuthErrorHandling(async ({ imageUrl, style, circleId = null }) => {
  const result = await rossArtTeacher({
    message: style.prompt,
    imageUrl,
    intent: 'edit',
    circleId: circleId || null,
    messageHistory: [],
  });
  return result.data;
});

const createPrintCheckout = httpsCallable(functions, 'createPrintCheckout');

export async function orderPrint({ imageUrl, productType, size, recipient, returnUrl }) {
  const result = await createPrintCheckout({
    imageUrl,
    productType,
    size,
    recipient,
    returnUrl: returnUrl || window.location.origin,
  });
  return result.data;
}

export async function saveArtworkToGallery({ circleId, imageUrl, fullResImageUrl, createdByUserId, createdByDisplayName, savedByUserId, prompt, timestamp }) {
  const galleryRef = collection(db, 'galleryArtworks');
  return addDoc(galleryRef, {
    circleId,
    imageUrl: fullResImageUrl || imageUrl,
    createdByUserId,
    createdByDisplayName,
    savedByUserId,
    prompt: prompt || '',
    timestamp: timestamp || Date.now(),
    savedAt: serverTimestamp(),
  });
}

export async function setActiveArtwork(circleId, isActive) {
  const circleRef = doc(db, 'artPingPongCircles', circleId);
  await updateDoc(circleRef, {
    activeArtworkStartedAt: isActive ? serverTimestamp() : null,
    lastUpdated: serverTimestamp(),
  });
}

export function subscribeToCircleDoc(circleId, callback) {
  return onSnapshot(doc(db, 'artPingPongCircles', circleId), (snap) => {
    if (snap.exists()) {
      callback({ id: snap.id, ...snap.data() });
    }
  });
}
